import React, { useState, useEffect } from "react";

// import { makeStyles } from '@mui/material/styles';
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import Host from "../../../assets/js/Host";
import Grid from "@mui/material/Grid";
import APP_CONSTANTS from "../../../assets/js/constants";
import DateFnsUtils from "@date-io/date-fns";
import { Box, Checkbox, Tooltip } from "@mui/material";
import { ThemeProvider } from "@mui/styles";
// import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import TextArea from "devextreme-react/text-area";
import DropDownMulti from "./DropDownMulti";
import { CheckBox } from "devextreme-react/check-box";
import Slider from "@mui/material/Slider";
import { LoadPanel } from "devextreme-react/load-panel";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../../Components/CustomTextField";
import { ContainerOfInputFields } from "../../../Components/ThemDesign";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomeSelectField from "../../../Components/CustomeSelectField";
import PopupForm from "../../../Components/PopupForm";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CachedIcon from "@mui/icons-material/Cached";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { setGlobalLoading } from "../../../reduxStore/SettingsReducer";
import { debounce } from "debounce";
import axios from "../../../assets/js/AxiosInterceptors";

const indicatorUrl =
  "https://js.devexpress.com/Content/data/loadingIcons/rolling.svg";

const cookies = new Cookies();

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1e6a99",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const RenderContent = (props) => {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [searchTechnicians, setSearchTechnicians] = useState("");
  const [searchEngineers, setSearchEngineers] = useState("");
  const [selctedMissionType, setSelectedMissionType] = useState([]);
  var headers = {
    jwt: cookies.get("token"),
  };
  useEffect(() => {
    console.log("props?.missionTypes", props?.missionTypes);
    if (props?.missionTypes) {
      let arr = [];
      props?.missionTypes &&
        props?.missionTypes?.map((itm) => {
          let check = props?.missionData?.missionTypeSelectedItemKeys?.includes(
            itm?.id
          );
          if (check) {
            arr.push(itm);
          }
        });
      setSelectedMissionType(arr);
    }
  }, [props?.missionData?.missionTypeSelectedItemKeys, props?.missionTypes]);

  const handleChangeTechnicians = (e, data, number) => {
    console.log("entersdnow");
    let arr = [];
    if (number == 1) {
      props?.data?.availableTechniciansResources &&
        props?.data?.availableTechniciansResources?.map((itm) => {
          if (itm?.ID == data?.ID) {
            arr?.push({
              ...itm,
              teamLeader: e?.target?.checked == true ? 1 : 0,
              executor: itm?.executor ? itm?.executor : 0,
            });
          } else {
            arr?.push({
              ...itm,
              teamLeader: 0,
              executor: itm?.executor ? itm?.executor : 0,
            });
          }
        });
    } else {
      props?.data?.availableTechniciansResources &&
        props?.data?.availableTechniciansResources?.map((itm) => {
          if (itm?.ID == data?.ID) {
            arr?.push({
              ...itm,
              executor: e?.target?.checked == true ? 1 : 0,
            });
          } else {
            arr?.push({
              ...itm,
              executor: itm?.executor ? itm?.executor : 0,
            });
          }
        });
    }
    if (arr && arr?.length > 0) props?.setAvailableTechniciansResources(arr);
  };

  const handleChangeEngineers = (e, data, number) => {
    console.log("entersdnow");
    let arr = [];
    if (number == 1) {
      props?.data?.availableEngineersResources &&
        props?.data?.availableEngineersResources?.map((itm) => {
          if (itm?.ID == data?.ID) {
            arr?.push({
              ...itm,
              teamLeader: e?.target?.checked == true ? 1 : 0,
              executor: itm?.executor ? itm?.executor : 0,
            });
          } else {
            arr?.push({
              ...itm,
              teamLeader: 0,
              executor: itm?.executor ? itm?.executor : 0,
            });
          }
        });
    } else {
      props?.data?.availableEngineersResources &&
        props?.data?.availableEngineersResources?.map((itm) => {
          if (itm?.ID == data?.ID) {
            arr?.push({
              ...itm,
              executor: e?.target?.checked == true ? 1 : 0,
            });
          } else {
            arr?.push({
              ...itm,
              executor: itm?.executor ? itm?.executor : 0,
            });
          }
        });
    }
    if (arr && arr?.length > 0) props?.setAvailableEngineersResources(arr);
  };
  return (
    <Box className="Container-fluid" sx={{ width: "100%" }}>
      <Box className="row pt-4 justify-content-between">
        <Box
          className="col-12 col-sm-12 col-md-6 col-lg-3 my-2"
          sx={{
            boxShadow: "0 0 6px -2px #000",
            borderRadius: "5px",
            padding: "10px 10px 20px 10px",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "cairo",
              color: "#1e6a99",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Technicians
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <CustomTextField
              label={"Search..."}
              haswidth={true}
              value={searchTechnicians}
              error={false}
              customWidth="100%"
              hasMultipleLine={false}
              paddingHorizontal="2px 0 2px 0 !important"
              message={""}
              readOnly={false}
              onChange={(e) => {
                setSearchTechnicians(e?.target?.value);
              }}
              onClearClick={() => {
                setSearchTechnicians("");
              }}
            />
          </Box>

          <TableContainer sx={{ marginTop: "10px" }}>
            <Table sx={{ width: "100%" }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{ width: "50%" }}>Name</StyledTableCell>
                  <StyledTableCell sx={{ width: "35%" }}>
                    Team Leader
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: "15%" }}>
                    Executor
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props?.data?.availableTechniciansResources?.map((row) =>
                  row?.name
                    ?.toString()
                    ?.toLowerCase()
                    .includes(searchTechnicians?.toString()?.toLowerCase()) ||
                  !searchTechnicians ? (
                    <StyledTableRow key={row.name}>
                      <StyledTableCell>{row?.name}</StyledTableCell>
                      <StyledTableCell align="left">
                        <Checkbox
                          {...label}
                          checked={row?.teamLeader == 1 ? true : false}
                          onChange={(e) => handleChangeTechnicians(e, row, 1)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="left">
                        <Checkbox
                          {...label}
                          checked={row?.executor == 1 ? true : false}
                          onChange={(e) => handleChangeTechnicians(e, row, 2)}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : null
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          className="col-12 col-sm-12 col-md-6 col-lg-3 my-2"
          sx={{
            boxShadow: "0 0 6px -2px #000",
            borderRadius: "5px",
            padding: "10px 10px 20px 10px",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "cairo",
              color: "#1e6a99",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "15px",
            }}
          >
            Engineers
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <CustomTextField
              label={"Search..."}
              haswidth={true}
              value={searchEngineers}
              error={false}
              customWidth="100%"
              hasMultipleLine={false}
              paddingHorizontal="2px 0 2px 0 !important"
              message={""}
              readOnly={false}
              onChange={(e) => {
                setSearchEngineers(e?.target?.value);
              }}
              onClearClick={() => {
                setSearchEngineers("");
              }}
            />
          </Box>

          <TableContainer sx={{ marginTop: "10px" }}>
            <Table sx={{ width: "100%" }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{ width: "50%" }}>Name</StyledTableCell>
                  <StyledTableCell sx={{ width: "35%" }}>
                    Team Leader
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: "15%" }}>
                    Executor
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props?.data?.availableEngineersResources?.map((row) =>
                  row?.name
                    ?.toString()
                    ?.toLowerCase()
                    .includes(searchEngineers?.toString()?.toLowerCase()) ||
                  !searchEngineers ? (
                    <StyledTableRow key={row.name}>
                      <StyledTableCell>{row?.name}</StyledTableCell>
                      <StyledTableCell>
                        <Checkbox
                          {...label}
                          checked={row?.teamLeader == 1 ? true : false}
                          onChange={(e) => handleChangeEngineers(e, row, 1)}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <Checkbox
                          {...label}
                          checked={row?.executor == 1 ? true : false}
                          onChange={(e) => handleChangeEngineers(e, row, 2)}
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : null
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          className="col-12 col-sm-12 col-md-6 col-lg-5 my-2"
          sx={{
            boxShadow: "0 0 6px -2px #000",
            borderRadius: "5px",
            padding: "10px 10px 20px 10px",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "Cairo",
              color: "#1e6a99",
              fontSize: "20px",
              fontWeight: "bold",
              marginBottom: "19px",
            }}
          >
            Mission Details
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column-reverse",
              justifyContent: "space-between",
              alignItems: "flex-start",
              flexWrap: "wrap",
              marginTop: "10px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                flexDirection: "column",
              }}
            >
              <ContainerOfInputFields
                mainTheme={maintheme}
                customeWidth={"100%"}
                hasError={false}
                haswidth={true}
              >
                <Box
                  sx={{
                    position: "relative",
                    // margin: "5px 0",
                    width: "100%",
                    backgroundColor: "#fff",
                  }}
                  className="mt-3 orderdata"
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label={"Select Execution time"}
                      //   inputFormat="MM/DD/YYYY HH:mm:ss"
                      value={
                        props?.executionTime
                          ? new Date(props?.executionTime)
                          : null
                      }
                      inputProps={{
                        placeholder: "لم يتم التحديد",
                      }}
                      onChange={props?.handleDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="filled"
                          focused={true}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: "لم يتم التحديد",
                          }}
                        />
                      )}
                    />
                    {props?.missionData?.executionTime ? (
                      <CloseIcon
                        className="closeIcon"
                        onClick={() => props?.handleDateChange(null)}
                        sx={{
                          right: "37px !important",
                          top: "14px !important",
                        }}
                      />
                    ) : null}
                  </LocalizationProvider>
                </Box>
              </ContainerOfInputFields>
              <Box sx={{ marginTop: "20px" }}></Box>

              <CustomeSelectField
                label={"Mission Types"}
                haswidth={true}
                customWidth="100%"
                value={selctedMissionType ? selctedMissionType : []}
                list={props?.missionTypes ? props?.missionTypes : []}
                customGetOptionLabel={(option) => option?.name}
                error={false}
                message={[]}
                limits={2}
                multiple={true}
                readOnly={false}
                focused={true}
                onChange={(e, newValue) => {
                  props?.onSelectedMissionTypeKeysChange(
                    newValue?.map((itm) => itm?.id)
                  );
                }}
                onClearClick={() => {
                  props?.onSelectedMissionTypeKeysChange(null);
                }}
              />
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                height: "200px",
                padding: "15px 0",
              }}
            >
              <Box
                sx={{
                  width: "50%",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Box sx={{ marginBottom: "10px" }}>
                  Duration : {props?.duration}
                </Box>
                <Slider
                  aria-label="Temperature"
                  orientation="vertical"
                  getAriaValueText={props?.valuetext}
                  valueLabelDisplay="auto"
                  step={1}
                  label="Hour"
                  min={0}
                  max={12}
                  marks={props?.marksHour}
                  value={props?.missionData?.durationHours}
                  onChange={props?.hourChanged}
                />
              </Box>
              <Box
                sx={{
                  width: "50%",
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                <Box
                  sx={{
                    marginBottom: "0px",
                    position: "relative",
                    top: "-6px",
                  }}
                >
                  All Day:{" "}
                  <Checkbox
                    checked={props?.durationAllDay ? true : false}
                    onChange={props?.onAllDayValueChanged}
                  />
                </Box>
                <Slider
                  aria-label="Temperature"
                  orientation="vertical"
                  getAriaValueText={props?.valuetext}
                  valueLabelDisplay="auto"
                  step={15}
                  label="Min"
                  min={0}
                  max={45}
                  marks={props?.marks}
                  value={
                    props?.missionData?.durationMinutes
                      ? props?.missionData?.durationMinutes
                      : 0
                  }
                  onChange={props?.minuteChanged}
                />
              </Box>
            </Box>
          </Box>
          <Box
            item
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              width: "99%",
              marginTop: "25px",
              position: "relative",
              left: "-3px",
            }}
          >
            <CustomeSelectField
              label={"Geo Fences"}
              customWidth="100%"
              haswidth={true}
              value={props?.selectedGeoFences ? props?.selectedGeoFences : null}
              list={props?.geoFences ? props?.geoFences : []}
              customGetOptionLabel={(option) => option?.name}
              error={false}
              message={[]}
              paddingHorizontal="2px 0 2px 0 !important"
              multiple={false}
              readOnly={false}
              loading={props?.loadingGeoURL}
              onSearch={(value) => {
                if (value?.target.value) {
                  props?.handleGeofenceSearch(value?.target.value);
                  if (
                    /^\s*(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)\s*$/.test(
                      value.target.value.trim()
                    )
                  ) {
                    props?.fetchGeofence(value.target.value);
                  } else if (
                    /^(https?:\/\/)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(\/[^\s]*)?$/.test(
                      value.target.value.trim()
                    )
                  ) {
                    toast.warning(
                      'Invalid coordinates, correct format: "33.33683514510023, 44.32034501730882"'
                    );
                  }
                }
              }}
              focused={true}
              onChange={(e, newValue) => {
                props?.setSelectedGeofences(newValue);
                props?.onSelectedGeoFenceKeysChange(newValue);
              }}
              onClearClick={() => {
                props?.setSelectedGeofences(null);
                props?.onSelectedGeoFenceKeysChange(null);
              }}
            />
            <Tooltip arrow title={"show Location On Map"}>
              <IconButton
                onClick={props?.goToSelectedMapGeoFence}
                sx={{
                  backgroundColor: "#fff",
                  boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                  margin: "0 10px",
                }}
              >
                <LocationOnIcon sx={{ color: "#000" }} />
              </IconButton>
            </Tooltip>
            <Tooltip arrow title={"Refresh Geofences"}>
              <IconButton
                onClick={props?.reloadGeoFence}
                sx={{
                  backgroundColor: "#fff",
                  boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
                }}
              >
                <CachedIcon sx={{ color: "#000" }} />
              </IconButton>
            </Tooltip>
          </Box>
          <Box
            sx={{
              width: "100%",
              marginTop: "20px",
            }}
          >
            <CustomTextField
              label={"Instructions..."}
              haswidth={true}
              value={props.data.instructions ? props.data.instructions : ""}
              error={false}
              customWidth="100%"
              hasMultipleLine={true}
              // paddingHorizontal="2px 10px 2px 5px !important"
              message={""}
              readOnly={false}
              onChange={(e) => {
                props?.instructionChangeValue(e?.target);
              }}
              onClearClick={() => {
                props?.instructionChangeValue(null);
              }}
            />

            <Box sx={{ marginTop: "20px" }}></Box>

            <CustomeSelectField
              label={"Vehicle"}
              customWidth="100%"
              haswidth={true}
              value={props?.selectedVehicle ? props?.selectedVehicle : null}
              list={props?.vehicles ? props?.vehicles : []}
              customGetOptionLabel={(option) => option?.vehicle_number}
              error={false}
              message={[]}
              paddingHorizontal="2px 0 2px 0 !important"
              multiple={false}
              readOnly={false}
              focused={true}
              onChange={(e, newValue) => {
                props?.setSelectedVehicle(newValue);
                props?.onSelectedVehicleKeysChange(newValue?.id);
              }}
              onClearClick={() => {
                props?.setSelectedVehicle(null);
                props?.onSelectedVehicleKeysChange(null);
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
          }}
          className="my-2"
        >
          <Box
            className="container-fluid"
            sx={{
              width: "80%",
              height: "auto",
              marginTop: "20px",
              boxShadow: "0 0 6px -2px #000",
              borderRadius: "5px",
              padding: "10px 10px 20px 10px",
              backgroundColor: "#fff",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "Cairo",
                fontSize: "20px",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              TASK DETAIL
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Box className="col-12 col-sm-12 col-md-6 col-lg-4">
                <CustomTextField
                  label={"Title"}
                  haswidth={true}
                  value={
                    props &&
                    props.data &&
                    props.data.customer &&
                    props.data.customer.name
                      ? props.data.customer.name
                      : ""
                  }
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={false}
                  message={""}
                  readOnly={true}
                />
                <Box sx={{ marginTop: "10px" }}></Box>
                <CustomTextField
                  label={"Number of units"}
                  haswidth={true}
                  value={props.data.numberOfUnits}
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={false}
                  message={""}
                  readOnly={true}
                />
                <Box sx={{ marginTop: "10px" }}></Box>
                <CustomTextField
                  label={"Weight"}
                  haswidth={true}
                  value={props.data.weightSelected}
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={false}
                  message={""}
                  readOnly={true}
                />
                <Box sx={{ marginTop: "10px" }}></Box>
                <CustomTextField
                  label={"Deadline Date"}
                  haswidth={true}
                  value={props.data.deadlineDate}
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={false}
                  message={""}
                  readOnly={true}
                />
              </Box>
              <Box className="col-12 col-sm-12 col-md-6 col-lg-4">
                <CustomTextField
                  label={"Contacted person"}
                  haswidth={true}
                  value={props.data.contactedPerson}
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={false}
                  message={""}
                  readOnly={true}
                />
                <Box sx={{ marginTop: "10px" }}></Box>
                <CustomTextField
                  label={"Contacted number"}
                  haswidth={true}
                  value={props.data.contactedNumber}
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={false}
                  message={""}
                  readOnly={true}
                />
                <Box sx={{ marginTop: "10px" }}></Box>
                <CustomTextField
                  label={"Task type"}
                  haswidth={true}
                  value={props.data.taskType}
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={false}
                  message={""}
                  readOnly={true}
                />
                <Box sx={{ marginTop: "10px" }}></Box>
                <CustomTextField
                  label={"Monitored by"}
                  haswidth={true}
                  value={props.data.monitor}
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={false}
                  message={""}
                  readOnly={true}
                />
              </Box>
              <Box className="col-12 col-sm-12 col-md-6 col-lg-4">
                <CustomTextField
                  label={"Description"}
                  haswidth={true}
                  value={props.data.description}
                  error={false}
                  customWidth="100%"
                  hasMultipleLine={true}
                  message={""}
                  readOnly={true}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const RenderFooter = (props) => {
  const gridtheme = useSelector((state) => state.themeData.gridtheme);
  const [t] = useTranslation("common");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box display="flex">
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#f7f7f7",
              borderColor: gridtheme?.colorWhite,
              color: gridtheme?.colorblack,
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,
              "&:hover": {
                backgroundColor: "#f7f7f7",
                borderColor: gridtheme?.colorWhite,
                color: gridtheme?.colorblack,
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={props?.cancel}
          >
            {"Close"}
          </Button>
          <Button
            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "80px !important",
              minWidth: "80px !important",
              maxWidth: "80px !important",
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              props.submit();
            }}
          >
            {"Save"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default function CreateMissionDialog(props) {
  const dispatch = useDispatch();
  const [duration, setDuration] = useState("00:15");
  const [durationAllDay, setDurationAllDay] = useState(false);
  const [isLoadPanelVisible, setisLoadPanelVisible] = useState(false);
  const [geoFences, setGeoFences] = useState([]);
  const [selectedGeoFences, setSelectedGeofences] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [vehicles, setVehicles] = useState(props?.vehicles);
  const [loadingGeoURL, setLoadingGeoURL] = useState(false);
  var headers = {
    jwt: cookies.get("token"),
  };
  const [geofenceObject, setGeofenceObject] = useState({
    geo_name: "",
    geo_x: "",
    geo_y: "",
    geoFenceSelected: "",
  });
  const onSelectedGeoFenceKeysChange = async (args) => {
    if (args && args.value) {
      let data = null;
      try {
        if (args.value > 0) {
          data = await axios({
            url: Host + `tasks/geofence/` + args.value,
            method: "get",
            headers: headers,
          })
            .then((data) => {
              console.log("nameGEOFENCE", data.data.data);
              if (data.data.data && data.data.data.length > 0) {
                setGeofenceObject({
                  geoFenceSelected: args.value,
                  geo_x: data?.data?.data[0]?.x,
                  geo_y: data?.data?.data[0]?.y,
                  geo_name: data?.data?.data[0]?.name,
                });
              } else {
                toast.error("coudn't find the selected geofence");
                return;
              }
            })
            .catch(() => {
              toast.error("Error in getting the selected geofence");
              return;
            });
        } else {
          toast.error("Please select a geofence to pin it on the map");
          return;
        }
      } catch (err) {
        console.log(err?.message);
      }
    } else {
      setGeofenceObject({
        geo_name: "",
        geo_x: "",
        geo_y: "",
        geoFenceSelected: "",
      });
    }
  };
  const [data, setData] = useState({
    taskType: "",
    monitor: "",
    weightSelected: 0,
    deadlineDate: "",
    description: "",
    title: "",
    numberOfUnits: 0,
    numberOfUnits: 0,
    contactedNumber: 0,
    contactedPerson: "",
    availableTechniciansResources: [],
    availableEngineersResources: [],
    missionTypes: [],
  });

  const handleDateChange = (date) => {
    updateUnavailableResources(date);
    props.setExecutionTime(date);
    // setMissionData({
    //     ...missionData,
    //     executionTime: date,
    // })
  };
  const updateUnavailableResources = (date) => {
    setisLoadPanelVisible(true);
    axios({
      url:
        Host +
        `planning/unavailable_employees?params={"working_day":"${date}"}`,
      method: "GET",
      headers: headers,
    })
      .then((res) => {
        setisLoadPanelVisible(false);
        //console.log(res.data.data.data?res.data.data.data.filter(function (e) { return !e.unAvailable; }):[])

        props.setAvailableResources(
          res.data.data.data
            ? res.data.data.data.filter(function(e) {
                return !e.unAvailable;
              })
            : []
        );
      })
      .catch((err) => {
        setisLoadPanelVisible(false);
        toast.error("Network Error");
        //console.log(err)
      });
  };
  const handleHide = () => {
    setisLoadPanelVisible(false);
  };

  const handleClose = () => {
    const clearedMissionTypes = props.missionTypes.map((missionType) => {
      return {
        id: missionType.id,
        name: missionType.name,
      };
    });

    props.setMissionTypes(clearedMissionTypes);
    props.setOpenDialog(false);
  };

  const addMission = () => {
    var finalInstruction = props.data.instructions;
    if (props.data.instructions) {
      finalInstruction = finalInstruction?.replace(/'/g, "");
    }
    const dataToSend = {
      ...props.missionData,
      task_id: props.editTaskId,
      instructionValue: finalInstruction,
      executionTime: props.executionTime,
      geoFenceSelected: selectedGeoFences ? selectedGeoFences?.id : "",
      geo_x: selectedGeoFences ? selectedGeoFences?.x : "",
      geo_y: selectedGeoFences ? selectedGeoFences?.y : "",
      geo_name: selectedGeoFences ? selectedGeoFences?.name : "",
      engineersSelected: props.data.availableEngineersResources.filter(
        (item) => item.teamLeader == 1 || item.executor == 1
      ),
      techniciansSelection: props.data.availableTechniciansResources.filter(
        (item) => item.teamLeader == 1 || item.executor == 1
      ),
    };

    let headers = {
      jwt: cookies.get("token"),
    };
    setisLoadPanelVisible(true);
    axios({
      url: Host + "planning/insert_task_mission",
      method: "post",
      headers: headers,
      data: dataToSend,
    })
      .then((res) => {
        setisLoadPanelVisible(false);
        if (res.data.status === true) {
          const clearedMissionTypes = props.missionTypes.map((missionType) => {
            return {
              id: missionType.id,
              name: missionType.name,
            };
          });

          props.setMissionTypes(clearedMissionTypes);

          props.setOpenDialog(false);
          toast.success("Mission inserted successfully");
          props.updateTable();
          props.setMissionData({
            // TechniciansSelectedItemKeys:[],
            // EngineersSelectedItemKeys:[],
            missionTypeSelectedItemKeys: [],
            executionTime: new Date(),
            instructionValue: "",
            task_id: 0,
          });
        } else {
          if (res.data?.data?.message) toast.error(res.data?.data?.message);
          else toast.error("Couldn't insert the mission, try again later");
        }
      })
      .catch((err) => {
        setisLoadPanelVisible(false);
        toast.error("Network Error");
        //console.log(err)
      });
  };
  const onSave = () => {
    const engineersSelected = props.data.availableEngineersResources.filter(
      (item) => item.teamLeader == 1 || item.executor == 1
    );
    const techniciansSelection = props.data.availableTechniciansResources.filter(
      (item) => item.teamLeader == 1 || item.executor == 1
    );
    //console.log(missionData.missionTypeSelectedItemKeys.length, engineersSelected.length, techniciansSelection.length)
    if (
      props.missionData.missionTypeSelectedItemKeys.length <= 0 ||
      engineersSelected.length <= 0 ||
      techniciansSelection.length <= 0
    ) {
      toast.error(
        "Please, select at least one Technicians and one Engineers resources and one type"
      );
      return;
    }

    if (!selectedVehicle?.id) {
      toast.error("Please, select a vehicle");
      return;
    }
    if (
      techniciansSelection.filter((item) => item.teamLeader == 1).length <= 0
    ) {
      toast.error("Please, select at least one Technicians as a Team Leader");
      return;
    }
    if (
      props.missionData.durationMinutes == 0 &&
      props.missionData.durationHours == 0
    ) {
      toast.error("Please, select a duration");
      return;
    }
    if (!selectedGeoFences?.x || !selectedGeoFences?.y) {
      toast.error("Please, select geofence");
      return;
    }

    var now = new Date();
    if (props.executionTime < now) {
      //console.log("execution time in the past")
      var result = window.confirm(
        "The excution time is in the past, are you sure you want to continue?"
      );
      if (result == true) {
        addMission();
      } else {
        toast.error("operation canceled");
        props.setOpen(false);
      }
    } else {
      addMission();
    }
  };

  const onSelectedMissionTypeKeysChange = (args) => {
    //console.log(args)
    props.setMissionData({
      ...props.missionData,
      missionTypeSelectedItemKeys: args,
    });
  };

  const onSelectedVehicleKeysChange = (args) => {
    //console.log(args)
    props.setMissionData({
      ...props.missionData,
      vehicle_id: args,
    });
  };

  const instructionChangeValue = (event) => {
    //console.log(event)
    props.setData({
      ...props.data,
      instructions: event.value,
    });
    props.setMissionData({
      ...props.missionData,
      instructionValue: event.value,
    });
  };
  const minuteChanged = (event, value) => {
    setDurationAllDay(false);
    setDuration(props.missionData.durationHours + ":" + value);
    props.setMissionData({
      ...props.missionData,
      durationMinutes: value,
    });
  };
  const onAllDayValueChanged = (e) => {
    if (e.target?.checked) {
      props.setMissionData({
        ...props.missionData,
        durationMinutes: 45,
        durationHours: 23,
      });
      setDuration(23 + ":" + 45);
    }
    setDurationAllDay(e.target?.checked);
  };
  const hourChanged = (event, value) => {
    setDurationAllDay(false);
    //console.log(value)
    setDuration(value + ":" + props.missionData.durationMinutes);
    props.setMissionData({
      ...props.missionData,
      durationHours: value,
    });
  };
  const setAvailableTechniciansResources = (availableTechniciansResources) => {
    props.setData({
      ...props.data,
      availableTechniciansResources: availableTechniciansResources,
    });
  };
  const setAvailableEngineersResources = (availableEngineersResources) => {
    props.setData({
      ...props.data,
      availableEngineersResources: availableEngineersResources,
    });
  };

  const objectsEqual = (o1, o2) => {
    let match = false;
    if (typeof o1 === "object" && Object.keys(o1).length > 0) {
      match =
        Object.keys(o1).length === Object.keys(o2).length &&
        Object.keys(o1).every((p) => objectsEqual(o1[p], o2[p]));
    } else {
      match = o1 === o2;
    }
    return match;
  };

  const arraysEqual = (a1, a2) => {
    let finalMatch = [];
    let itemFound = [];

    if (a1.length === a2.length) {
      finalMatch = [];
      a1.forEach((i1) => {
        itemFound = [];
        a2.forEach((i2) => {
          itemFound.push(objectsEqual(i1, i2));
        });
        finalMatch.push(itemFound.some((i) => i === true));
      });
      return finalMatch.every((i) => i === true);
    } else {
      return false;
    }
  };

  useEffect(() => {
    const techniciansAvailable = props.availableResources
      ? props.availableResources
          .filter(
            (item) =>
              item.department_id == APP_CONSTANTS.TECHNICIANS_DEPARTMENT_ID
          )
          .map((item) => {
            return {
              ID: item.user_id,
              name: item.name,
              teamLeader: 0,
              executor: 0,
            };
          })
      : [];
    const engineersAvailable = props.availableResources
      ? props.availableResources
          .filter(
            (item) =>
              item.department_id == APP_CONSTANTS.ENGINEERS_DEPARTMENT_ID
          )
          .map((item) => {
            return {
              ID: item.user_id,
              name: item.name,
              teamLeader: 0,
              executor: 0,
            };
          })
      : [];

    const updatedTechniciansAvailable = techniciansAvailable.map((item) => {
      for (
        let index = 0;
        index < props.data.availableTechniciansResources.length;
        index++
      ) {
        const element = props.data.availableTechniciansResources[index];
        if (element.ID == item.ID) {
          return element;
        }
      }
      return item;
    });
    var techniciansListUpdated = false;

    console.log("missionTypes");
    console.log(props.missionTypes);

    if (
      props &&
      !props.firstOpen &&
      props.data &&
      props.data.availableTechniciansResources &&
      updatedTechniciansAvailable
    ) {
      var checkSelectionUpdate = false;
      props.data.availableTechniciansResources.map((item) => {
        if (item.teamLeader || item.executor) {
          checkSelectionUpdate = true;
        }
      });
      if (checkSelectionUpdate) {
        if (
          !arraysEqual(
            props.data.availableTechniciansResources,
            updatedTechniciansAvailable
          )
        ) {
          techniciansListUpdated = true;
        }

        if (techniciansListUpdated) {
          toast.warn("Technicians list updated");
        }
      }
    }

    const updatedEngineersAvailable = engineersAvailable.map((item) => {
      for (
        let index = 0;
        index < props.data.availableEngineersResources.length;
        index++
      ) {
        const element = props.data.availableEngineersResources[index];
        if (element.ID == item.ID) return element;
      }

      return item;
    });
    var engineersListUpdated = false;
    if (
      props &&
      !props.firstOpen &&
      props.data &&
      props.data.availableEngineersResources &&
      updatedEngineersAvailable
    ) {
      var checkSelectionUpdate = false;
      props.data.availableEngineersResources.map((item) => {
        if (item.teamLeader || item.executor) {
          checkSelectionUpdate = true;
        }
      });
      if (checkSelectionUpdate) {
        if (
          !arraysEqual(
            props.data.availableEngineersResources,
            updatedEngineersAvailable
          )
        ) {
          engineersListUpdated = true;
        }
        if (engineersListUpdated) {
          toast.warn("Engineers list updated");
        }
      }
    }

    props.setData({
      ...props.data,
      availableTechniciansResources: updatedTechniciansAvailable,
      availableEngineersResources: updatedEngineersAvailable,
    });

    props.setMissionData({
      ...props.missionData,
      task_id: props.editTaskId,

      instructionValue: props.data ? props.data.description : "",
    });

    props.setFirstOpen(false);
    return () => {};
  }, [props.availableResources, props.missionTypes]);

  function valuetext(value) {
    return `${value} H`;
  }
  const marks = [
    {
      value: 0,
      label: "0 min",
    },
    {
      value: 15,
      label: "15 min",
    },
    {
      value: 30,
      label: "30 min",
    },
    {
      value: 45,
      label: "45 min",
    },
  ];

  const marksHour = [
    {
      value: 0,
      label: "0 Hour",
    },
    {
      value: 3,
      label: "3 Hour",
    },
    {
      value: 6,
      label: "6 Hour",
    },
    {
      value: 9,
      label: "9 Hour",
    },
    {
      value: 12,
      label: "12 Hour",
    },
  ];
  const onCellPrepared = (e) => {
    e.cellElement.style.textAlign = "center";
  };

  useEffect(() => {
    loadDataOfGeoFence();
  }, []);
  const goToSelectedMapGeoFence = () => {
    if (selectedGeoFences?.x && selectedGeoFences?.y) {
      if (selectedGeoFences?.y < selectedGeoFences?.x) {
        window.open(
          `https://maps.google.com/?q=${selectedGeoFences?.y},${selectedGeoFences?.x}`,
          "_blank"
        );
      } else {
        window.open(
          `https://maps.google.com/?q=${selectedGeoFences?.x},${selectedGeoFences?.y}`,
          "_blank"
        );
      }
    } else {
      toast.error("Please select a geofence to pin it on the map");
      return;
    }
  };
  const reloadGeoFence = () => {
    reloadGeoFenceRequest();
  };
  const reloadGeoFenceRequest = () => {
    // setisLoadPanelVisible(true);
    dispatch(setGlobalLoading(true));
    axios({
      url: Host + `tasks/geofence_reload`,
      method: "GET",
      headers: headers,
    })
      .then((res) => {
        dispatch(setGlobalLoading(false));

        if (res)
          //console.log("geofence loaded")
          toast.success("Geo Fence loaded successfully");
        //console.log("failed")
        else toast.error("Loading Geo Fence failed");
      })
      .catch((err) => {
        dispatch(setGlobalLoading(false));
      });
  };
  const loadDataOfGeoFence = async (searchParams) => {
    console.log("searchParams", searchParams);
    let data = null;
    let params = 'searchOperation="contains"&userData={}&';
    let paramsList = [];
    try {
      if (searchParams && searchParams?.length > 0) {
        params +=
          'searchExpr="' +
          searchParams[0] +
          '"&searchValue="' +
          searchParams[1] +
          '"';
      }

      data = await axios({
        url: Host + `tasks/geofence/page?${params}`,
        method: "get",
        headers: headers,
      }).then((data) => {
        setGeoFences(data?.data?.data);
      });
    } catch (err) {
      console.log(err?.message);
    }
  };
  const handleGeofenceSearch = debounce((value) => {
    let searchParams = ["name", value];
    loadDataOfGeoFence(searchParams);
  }, 500);

  async function expandShortUrl(shortUrl) {
    try {
      setLoadingGeoURL(true);
      const response = await axios({
        url: Host + "tasks/fetch_google_maps_url",
        method: "GET",
        headers: {
          jwt: cookies.get("token"),
        },
        params: {
          url: shortUrl,
        },
      });
      setLoadingGeoURL(false);
      return response?.data;
    } catch (error) {
      console.error("Error expanding URL:", error);
      setLoadingGeoURL(false);
      return null;
    }
  }

  async function extractCoordinates(url) {
    const coords = url.split(",");

    const latitude = coords[0];
    const longitude = coords[1];

    return {
      latitude: JSON.parse(latitude),
      longitude: JSON.parse(longitude),
    };
  }

  const fetchGeofence = async (location) => {
    // Extract place ID or coordinates from Google Maps URL
    if (typeof location === "string" && location?.length) {
      const result = await extractCoordinates(location);
      if (result?.latitude && result?.longitude) {
        setSelectedGeofences({
          id: 1,
          name: "موقع مسترجع من رابط",
          x: result?.longitude,
          y: result?.latitude,
        }); 

        setData({
          ...props?.data,
          geoFenceSelected: [
            {
              name: "موقع مسترجع من رابط",
              x: result?.longitude,
              y: result?.latitude,
            },
          ],
        });
      } else {
        toast.error(
          "There is an issue with the URL format, please fix it or provide a different one."
        );
      }
    } else {
      console.error("Not a valid Google Maps URL");
    }
  };

  return (
    <PopupForm
      open={props.openDialog ? true : false}
      setOpen={() => {
        handleClose();
      }}
      isFullScreen={true}
      width="100%"
      customeHeight="100%"
      customePadding="0"
      title={"Creat a Mission to Task " + props?.editTaskId}
      content={
        <RenderContent
          data={data}
          {...props}
          missionData={props?.missionData}
          onCellPrepared={onCellPrepared}
          setAvailableEngineersResources={setAvailableEngineersResources}
          setAvailableTechniciansResources={setAvailableTechniciansResources}
          handleDateChange={handleDateChange}
          onSelectedMissionTypeKeysChange={onSelectedMissionTypeKeysChange}
          duration={duration}
          valuetext={valuetext}
          marksHour={marksHour}
          hourChanged={hourChanged}
          durationAllDay={durationAllDay}
          onAllDayValueChanged={onAllDayValueChanged}
          marks={marks}
          minuteChanged={minuteChanged}
          instructionChangeValue={instructionChangeValue}
          missionTypes={props?.missionTypes}
          executionTime={props?.executionTime}
          handleGeofenceSearch={handleGeofenceSearch}
          fetchGeofence={fetchGeofence}
          loadingGeoURL={loadingGeoURL}
          loadDataOfGeoFence={loadDataOfGeoFence}
          geoFences={geoFences}
          selectedGeoFences={selectedGeoFences}
          setSelectedGeofences={setSelectedGeofences}
          onSelectedGeoFenceKeysChange={onSelectedGeoFenceKeysChange}
          reloadGeoFence={reloadGeoFence}
          goToSelectedMapGeoFence={goToSelectedMapGeoFence}
          onSelectedVehicleKeysChange={onSelectedVehicleKeysChange}
          setSelectedVehicle={setSelectedVehicle}
          selectedVehicle={selectedVehicle}
          vehicles={vehicles}
        />
      }
      footer={
        <RenderFooter
          open={props.addForm}
          setOpen={props.setAddForm}
          submit={onSave}
          cancel={handleClose}
        />
      }
    />
  );
}
